import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const SurveyGroupReducer = createSlice({
    name: "surveyGroup",
    initialState,
    reducers: {
        setSurveyGroupData: (state, action) => {
            state.length = 0;
            action.payload.map(obj => {
                state.push(obj);
            });
        },
        updateSurveyGroup: (state, action) => {
            let objIndex = state.findIndex(stateObj => {
                return (stateObj._id === action.payload._id) ;
            });

            if (objIndex >= 0) {
                state.splice(objIndex, 1, action.payload);
            } else if(objIndex === -1) {
                state.push(action.payload);
            }
        }
    }
});
export const {setSurveyGroupData, updateSurveyGroup} = SurveyGroupReducer.actions;

export default SurveyGroupReducer.reducer;